import React, { Component } from 'react'
import Home from "../Components/Home/home.jsx"

export default class home extends Component {
    render() {
        return <h1>Page2</h1>
    }
}
